import React, {useState} from 'react';
import { CardBody,  Col, Form, FormGroup, Label, Row} from 'reactstrap';
import { ButtonClean, ButtonSearch, } from "../../../components/buttons/buttonsActions";
import {useForm} from "react-hook-form";
import SelectGeneric from "../../../components/select/selectGeneric";
import {categoryProductProvider} from "../../../providers/categoryProductProvider";

export default function SalesPackageFilters(props) {

    const [fbDataBaseId] = useState(props?.app?.fbDataBase?.id);
    const [categoryProductId, setCategoryProductId] = useState(null);

    const {handleSubmit, reset} = useForm();

    const onSubmit = (data, _) => {
        const dataFilter = {
            fbDataBase : {  id : fbDataBaseId },
            item : {
            }
        }

        if (categoryProductId !== undefined && categoryProductId !== null && categoryProductId !== '')
            dataFilter.item.categoryProduct = { id : categoryProductId };

        props.refreshFiltered(dataFilter);
    };

    const cleanFields = () => {
        setCategoryProductId(null);
        reset();
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>Cagetoria del producto</Label>
                            <SelectGeneric
                                initialValue={ categoryProductId }
                                setExternalValue={ value => setCategoryProductId( value ) }
                                isDisabled={ false }
                                provider = { categoryProductProvider }
                                fbDataBaseId = { fbDataBaseId }
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}